import WordInsideListArea from "@/pages/comp/plan/word/word_inside/common/use_stu_list";

function WordInsideUseStuLisePopup(props: any) {
  let myProps = {
    closePopup: () => { },
    refreshData: (inData: any) => { },
    callbackData: (inData: any) => { },
    inside_seq: "",
    ...props
  };

  return (
    <div>
      <WordInsideListArea
        closePopup={myProps.closePopup}
        refreshData={myProps.refreshData}
        callbackData={myProps.callbackData}
        inside_seq={myProps.inside_seq}
      ></WordInsideListArea>
    </div>
  );
};
export default WordInsideUseStuLisePopup;